import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import withRouter from "../../components/Common/withRouter";

class EditCtaSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "CTA Section", link: "/cta-section" },
        { title: "Edit CTA Section", link: "#" },
      ],
      title: "",
      subtitle: "",
      buttonName: "",
      navigationUrl: "",
      ctaSectionId: null,
      rightImage: null,
      rightImagePreview: null,
    };
  }

  componentDidMount() {
    const { ctaSection } = this.props.router.location.state || {};
    if (ctaSection) {
      this.setState({
        title: ctaSection.title,
        subtitle: ctaSection.subtitle,
        buttonName: ctaSection.buttonName,
        navigationUrl: ctaSection.navigationUrl,
        ctaSectionId: ctaSection._id,
        rightImage: ctaSection.rightImage,
        rightImagePreview: ctaSection.rightImage ? `${config.IMAGE_URL}/${ctaSection.rightImage}` : null,
      });
    } else {
      const id = this.props.router.params.id;
      if (id) this.fetchCtaSection(id);
    }
  }

  fetchCtaSection = async (id) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/cta-section/${id}`);
      const data = await response.json();
      if (response.ok) {
        this.setState({
          title: data.title,
          subtitle: data.subtitle,
          buttonName: data.buttonName,
          // navigationUrl: data.navigationUrl,
          ctaSectionId: data._id,
          rightImage: data.rightImage,
          rightImagePreview: data.rightImage ? `${config.IMAGE_URL}/${data.rightImage}` : null,
        });
      }
    } catch (error) {
      console.error("Error fetching CTA section:", error);
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        rightImage: file,
        rightImagePreview: URL.createObjectURL(file),
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const formData = new FormData();
        formData.append('title', this.state.title);
        formData.append('subtitle', this.state.subtitle);
        formData.append('buttonName', this.state.buttonName);
        formData.append('navigationUrl', this.state.navigationUrl);
        if (this.state.rightImage) {
            formData.append('rightImage', this.state.rightImage);
        }
        const response = await fetch(`${config.API_BASE_URL}/cta-section/${this.state.ctaSectionId}`, {
            method: "PUT",
            body: formData
        });
        const data = await response.json();
        if (response.ok) {
            console.log("CTA Section updated:", data);
            this.props.router.navigate("/cta-section");
        } else {
            alert(data.message || "Failed to update CTA section");
        }  
    } catch (error) {
        console.error("Error updating CTA section:", error);
        alert("Error updating CTA section");
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/cta-section");
  };

  render() {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Edit CTA Section"
            breadcrumbItems={this.state.breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Title</Label>
                          <Input
                            type="text"
                            name="title"
                            value={this.state.title}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Subtitle</Label>
                          <Input
                            type="text"
                            name="subtitle"
                            value={this.state.subtitle}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Button Name</Label>
                          <Input
                            type="text"
                            name="buttonName"
                            value={this.state.buttonName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col>
                      {/* <Col md={6}>
                        <div className="mb-3">
                          <Label>Navigation URL</Label>
                          <Input
                            type="text"
                            name="navigationUrl"
                            value={this.state.navigationUrl}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col> */}
                      <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Image</Label>
                            <Input
                              type="file"
                              className="form-control"
                              onChange={this.handleImageChange}
                              accept="image/*"
                            />
                            {this.state.rightImagePreview && (
                              <img
                                src={this.state.rightImagePreview}
                                alt="Image Preview"
                                className="img-fluid mt-2"
                                style={{ maxHeight: "200px" }}
                              />
                            )}
                          </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col className="d-flex justify-content-end">
                        <Button type="submit" color="primary" className="me-2">
                          Update CTA Section
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={this.handleCancel}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(EditCtaSection);
